// 租户后台现货返佣仅使用简体中文。
export default {
  "title": "现货返佣",
  "coin": "手续费币种",
  "start": "统计起点",
  "note": "仅统计启用后手续费；总手续费包含禁止返佣部分。",
  "incomeNote": "整体已发包含直属普通用户贡献，两个收益不能相加。",
  "totalFee": "总手续费",
  "totalFeeU": "发生时折U总手续费",
  "deductFee": "禁止返佣扣减手续费",
  "actualFee": "实际手续费",
  "eligibleFee": "参与返佣手续费",
  "directFee": "直属普通用户手续费",
  "teamFee": "本人及下级团队手续费",
  "directIncome": "直属普通用户已发贡献",
  "overallIncome": "整体已发返佣",
  "payable": "应发返佣",
  "paid": "已发返佣",
  "deductRebate": "扣减返佣",
  "rate": "本级比例",
  "diff": "差额比例",
  "multi": "多比例",
  "interval": "生效区间",
  "raw": "原始返佣",
  "allocated": "结算分摊",
  "status": "状态",
  "order": "订单号",
  "exec": "成交号",
  "user": "交易用户UID",
  "partner": "合伙人UID",
  "day": "手续费发生日",
  "refresh": "查询",
  "prev": "上一页",
  "next": "下一页",
  "UNSETTLED": "待结算",
  "READY": "待发放",
  "UNKNOWN": "核对中",
  "DEBITED": "已扣款待入账",
  "SUCCESS": "已发放",
  "NO_PAYMENT": "无需发放",
  "BLOCKED": "待处理",
  "unavailable": "现货返佣未启用或暂不可用",
  "error": "操作失败，请检查权限、参数和服务状态后重试。",
  "save": "保存现货设置",
  "disabled": "不返佣",
  "daily": "自动日返（次日19点）",
  "mode": "现货返佣模式（顶级合伙人）",
  "risk": "现货禁止返佣",
  "restore": "解除现货禁止返佣",
  "saved": "保存成功",
  "ratioHint": "现货比例（%），下级不得高于上级",
  "details": "现货明细",
  "prohibited": "禁止返佣",
  "allTitle": "全部返佣（合约＋现货）",
  "batches": "日结算批次",
  "batch": "批次号",
  "due": "计划发放时间",
  "separateRate": "现货比例请使用本页“现货返佣”入口修改。",
  "initializing": "统计起点尚未建立，服务启动后会自动初始化；校验失败会自动重试，请检查服务日志并修正相关配置。"
}
